import React, { useCallback } from 'react';
import { Button, Pane, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { connect } from 'react-redux';
import { Auth } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
import { push } from 'connected-react-router';
import LogoComponent from "./views/LogoComponent.js";
const {
  t
} = I18N.ns('login.DeviceCodeSuccess');
function DeviceCodeSuccess(props) {
  const {
    isLoggedIn
  } = props;
  const onDismissSuccess = useCallback(() => {
    GlobalState.dispatch(push('/'));
  }, []);
  return /*#__PURE__*/React.createElement(Pane, {
    variant: "loginPane"
  }, /*#__PURE__*/React.createElement(Pane, {
    variant: "loginPaneHalf",
    layout: "flex:colLCenterMiddle"
  }, /*#__PURE__*/React.createElement(LogoComponent, {
    variant: "loginLogo"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "formTitleCenter"
  }, t('title')), /*#__PURE__*/React.createElement(Text, {
    variant: "formBodyCenter"
  }, t('instructions')), isLoggedIn && /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    style: {
      alignSelf: 'stretch'
    },
    onClick: onDismissSuccess
  }, t('done', 'Done'))));
}
export default connect(state => {
  return {
    isLoggedIn: Auth.isLoggedIn(state.auth)
  };
})(DeviceCodeSuccess);